export default {
	"route.dashboard": "Lista danych",
	"route.robot": "Robot",
	"route.robotList": "Lista robotów",
	"route.groupManage": "Zarządzanie grupami",
	"route.disinfect": "Zadanie",
	"route.home": "Strona główna",
	"route.disinfectTask": "Zadanie",
	"route.building": "Budynek",
	"route.accessControl": "Kontrola dostępu",
	"route.ladderControl": "Sterowanie windą",
	"route.IOT": "IOT",
	"route.accounts": "Konto",
	"route.roles": "Rola",
	"route.jurisdiction": "Uprawnienia",
	"route.dispatcher": "Dysponent zadań",
	"navbar.logOut": "Wylogowanie",
	"login.title": "Logowanie Enterprise ID",
	"login.logIn": "Zaloguj się",
	"login.username": "Nazwa użytkownika",
	"login.tip_username": "Proszę wpisać nazwę użytkownika",
	"login.password": "Hasło",
	"login.company_id": "Identyfikator przedsiębiorstwa",
	"login.tip_company": "Proszę podać identyfikator przedsiębiorstwa",
	"login.tip_pwd": "Proszę wprowadzić hasło",
	"robot.projectTtitle": "Platforma zarządzania robotami",
	"robot.manage": "Zarządzanie robotami",
	"system.search": "Wyszukaj",
	"system.reset": "Resetuj",
	"system.open": "Rozkładanie",
	"system.retract": "Składanie",
	"system.status": "Status",
	"system.inProgress": "W trakcie",
	"system.normalCompletion": "Zakończone",
	"system.abnormalEnd": "Nietypowe zakończenie",
	"system.noData": "Brak danych",
	"universality.confirm": "Potwierdź",
	"universality.cancel": "Anuluj",
	"universality.Pleasedonot": "Proszę nie wpisywać pustego miejsca",
	"universality.Pleaseifsymbols": "Proszę wprowadzić 6-20 cyfr, angielski, symbole specjalne",
	"disinfect.robotremarkname": "Uwaga robota",
	"disinfect.EnterNoteName": "Wprowadź uwagę",
	"disinfect.robotSerialNumber": "Numer seryjny robota",
	"disinfect.inputSequenceNumber": "Wprowadź numer seryjny",
	"disinfect.selectStatus": "Wybierz status",
	"disinfect.destination": "Miejsce docelowe",
	"disinfect.Enterdestination": "Wprowadź miejsce przeznaczenia",
	"disinfect.dates": "Data",
	"disinfect.tos": "Do",
	"disinfect.startDates": "Data początkowa",
	"disinfect.endDates": "Data końcowa",
	"disinfect.starttimes": "Godzina rozpoczęcia",
	"disinfect.endtimes": "Godzina końcowa",
	"disinfect.Lastweek": "Ostatni tydzień",
	"disinfect.Lastmonth": "Ostatni miesiąc",
	"disinfect.Lastthreemonths": "Ostatnie 3 miesiące",
	"disinfect.nonExecution": "Nie zrealizowane",
	"disinfect.canceled": "Anuluj",
	"disinfect.UnclaimedProperty": "Nikt nie odbiera posiłków",
	"disinfect.hardwareFailure": "Awaria sprzętu",
	"disinfect.NavigationFault": "Awaria nawigacji",
	"disinfect.Manualcancellation": "Ręczne anulowanie",
	"navigationBar.logout": "Wyloguj się",
	"navigationBar.logoutandsystem": "Wylogowanie z konta i systemu?",
	"account.userlist": "Lista użytkowników",
	"account.searchnames": "Wyszukaj",
	"account.adduser": "Dodaj użytkownika",
	"account.user": "Użytkownik",
	"account.roles": "Rola",
	"account.ResponsibleRobot": "Robot z użytkownika",
	"account.name": "Nazwa",
	"account.remark": "Memo",
	"account.Recentloginiof": "Ostatnie informacje dotyczące logowania",
	"account.operation": "Operacja",
	"account.compile": "Edycja",
	"account.resetpasswords": "Resetowanie hasła",
	"account.delete": "Usuń",
	"account.pleaseuserpasnumb": "6-20 angielskich liter, cyfr, znaków specjalnych",
	"account.pleasepasswordnumb": "Wpisz hasło (6-20 angielskich liter, cyfr, znaków specjalnych)",
	"account.selectroles": "Wybierz rolę",
	"account.selectbuild": "Wybierz budynek",
	"account.inputnames": "Proszę wprowadzić nazwę użytkownika",
	"account.inputremarks": "Proszę wprowadzić uwagi",
	"account.userdetail": "Dane użytkownika",
	"account.noBindingRobot": "Nie ma robotów",
	"account.addtimes": "Czas dodania",
	"account.LastonlineTime": "Czas ostatniego logowania",
	"account.Resetsuccessfully": "Udane resetowanie",
	"account.initialPassword": "Oryginalne hasło",
	"account.gotIt": "Wiem",
	"account.PleaseRoles": "Proszę wybrać rolę",
	"account.Pleasebuilds": "Proszę wybrać budynek",
	"account.PleaseRobots": "Proszę wybrać robota",
	"account.compileusers": "Edytuj konto",
	"account.deleteusers": "Usuń konto",
	"account.Unabletologinafterdeleting": "Nie można się zalogować po usunięciu konta, proszę potwierdzić",
	"account.alreadyexistsConfirmpasswords": "Zresetować hasło do oryginalnego hasła?",
	"account.alreadyExists": "Konto już istnieje",
	"map.deleteThecloudmap": "Usunięcie mapy chmury spowoduje jednoczesne usunięcie wszystkich map powiązanych z robotem. Czy jesteś pewien, że chcesz usunąć?",
	"map.deletemaps": "Usuń mapę",
	"homes.robotTotal": "Całkowita liczba robotów (jednostek)",
	"homes.tasksTotal": "Całkowita liczba skumulowanych zadań",
	"homes.onlineTimeTotal": "Skumulowany czas online",
	"homes.nearly-7-days-onlineTime": "Trend czasu online w ciągu ostatnich 7 dni",
	"homes.cumulativeMileage": "Skumulowany przebieg (metry)",
	"homes.robotWorkingHoursData": "Dane dotyczące godzin pracy robotów",
	"homes.trendWorkingHours": "Trend godzin pracy",
	"homes.explain": "Uwagi",
	"homes.explainContent": "Dane dotyczące dostaw robota w różnych budynkach",
	"homes.to": "Do",
	"homes.startTime": "Czas rozpoczęcia",
	"homes.endTime": "Czas zakończenia",
	"homes.proportionWorkingHours": "Proporcja godzin pracy",
	"homes.buildingDeliveryList": "Lista rankingowa czasów dostaw w budynku",
	"public.second": "Razy",
	"public.rice": "Metr",
	"public.lastSevenDays": "Ostatnie 7 dni",
	"public.lastFourteenDays": "Ostatnie 14 dni",
	"public.lastThirtyDays": "Ostatnie 30 dni",
	"robotState.notActive": "Nie aktywtowany",
	"robotState.abnormalEnd": "Nienormalny koniec",
	"robotState.hasLeft": "Odszedł",
	"robotState.online": "Online",
	"robotState.offline": "Offline",
	"robotState.charge": "Ładowanie",
	"robotState.unknown": "Nieznany",
	"robotState.atWork": "W pracy",
	"robotState.free": "Bezpłatnie",
	"robotState.unexecuted": "Niewykonane",
	"robotState.executing": "W trakcie realizacji",
	"robotState.canceled": "Anulowane",
	"robotState.Completed": "Zakończone",
	"robotState.nobodyTakesThings": "Nikt nie odbiera posiłków",
	"robot.robotList": "Lista robotów",
	"robot.buildings": "Budynek",
	"robot.selectBuilding": "Wybierz budynek",
	"robot.search": "Wyszukaj uwagę i numer seryjny",
	"robot.notAddRobot": "Żaden robot nie został dodany ani aktywowany",
	"robot.mileage": "Łączny przebieg",
	"robot.information": "Podstawowe informacje",
	"robot.noteName": "Uwaga",
	"robot.model": "Model",
	"robot.onlineStatus": "Status online",
	"robot.workingStatus": "Stan pracy",
	"robot.currentPower": "Aktualna moc",
	"robot.serialNumber": "Numer seryjny",
	"robot.operationData": "Dane eksploatacyjne",
	"robot.latestOnlineTime": "Ostatni czas online",
	"robot.cumulativeOnlineDuration": "Łączny czas przebywania w sieci",
	"robot.cumulativeDeliveryTimes": "Skumulowany czas dostawy",
	"robot.cumulative-delivery-time": "Skumulowany czas dostawy",
	"robot.cumulativeLeadTimes": "Skumulowany czas eskorty",
	"robot.cumulativeLeadTime": "Skumulowany czas eskorty",
	"robot.System-Hardware": "System i sprzęt",
	"robot.systemVersion": "Wersja systemu",
	"robot.hardwareStatus": "Status sprzętu",
	"robot.language": "Język systemu",
	"robot.voice_pack": "Pakiet głosowy",
	"robot.box_model": "Szafa",
	"robot.android_soft": "Oprogramowanie Android",
	"robot.android_mirror": "ROM Android",
	"robot.header_control": "Płyta sterująca głowicy",
	"robot.under_panel_version": "Wersja podwozia",
	"robot.under_mirror": "Obraz systemu operacyjnego podwozia",
	"robot.under_master": "Główna kontrola podwozia",
	"robot.under_control": "Płyta sterująca podwozia",
	"robot.rgbd_up": "RGBD(góra)",
	"robot.rgbd_down": "RGBD(dół)",
	"robot.doorControlMotor": "Silnik sterujący drzwiami",
	"robot.frontMountedCamera": "Kamera przednia",
	"robot.overheadCamera": "Kamera górna",
	"robot.infraredDetectionBox": "Detekcja podczerwieni",
	"robot.microphone": "Mikrofon",
	"robot.radar": "Lidar",
	"robot.head-RGBD": "Głowica RGBD",
	"robot.bottom-RGBD": "Dolny RGBD",
	"robot.ultrasonicSensor": "Czujnik ultradźwiękowy",
	"robot.IMU": "IMU",
	"robot.hubMotor": "Silnik piasty",
	"robot.emergencyStopSwitch": "Przycisk zatrzymania awaryjnego",
	"robot.horn": "Głośnik",
	"robot.getFailed": "Nie udało się",
	"robot.normal": "Normalny",
	"robot.abnormal": "Nienormalny",
	"robot.cancel": "Usuń",
	"robot.confirm": "Potwierdź",
	"public.noteNameCannotBeEmpty": "Uwaga nie może być pusta",
	"public.layer": "Piętro",
	"public.door": "Budynek",
	"public.rename": "Zmień nazwę",
	"public.delete": "Usuń",
	"robot.percentageTasksCompletedTotal": "Procent skumulowanych zadań zakończonych",
	"robotState.workSuspension": "Zawieszenia zadań",
	"buiding.buildingList": "Lista budynków",
	"buiding.add": "Dodaj",
	"buiding.addFloors": "Dodaj piętro",
	"buiding.pleaseCompleteBuidingsData": "Proszę uzupełnić dane budynku w liście po lewej stronie!",
	"buiding.map": "Mapa",
	"buiding.source": "Źródło",
	"buiding.uploadTime": "Czas ładowania",
	"buiding.pleaseRobotUploadMap": "Proszę załadować mapę do robota",
	"buiding.associatedBuildings": "Powiązane budynki",
	"buiding.robot": "Robot",
	"buiding.associatedRobot": "Powiązane roboty",
	"buiding.associatedShop": "Powiązane sklepy",
	"buiding.type": "Typ",
	"buiding.pleaseType": "Proszę wybrać typ",
	"buiding.buildingName": "Nazwa budynku",
	"buiding.pleaseBuildingName": "Proszę wprowadzić nazwę budynku",
	"buiding.shopName": "Nazwa sklepu",
	"buiding.pleaseShopName": "Proszę wpisać nazwę sklepu",
	"buiding.floor": "Piętro",
	"buiding.floorName": "Nazwa piętra",
	"buiding.pleaseFloorName": "Nazwa piętra",
	"buiding.floorNameBeEmpty": "Nazwa piętra nie może być pusta",
	"buiding.buid": "Budynek",
	"buiding.shop": "Sklep",
	"buiding.serialNumberCannotBeEmpty": "Numer seryjny nie może być pusty",
	"buiding.buildingAdd": "Dodaj budynek",
	"buiding.pleaseBuilsdingName": "Proszę dodać nazwę budynku",
	"buiding.buildingsNameBeEmpty": "Nazwa budynku nie może być pusta",
	"buiding.AreYouSureToDeleteThisFloor": "Czy na pewno chcesz usunąć \"piętro\"?",
	"buiding.deleteFloor": "Usuń piętro",
	"buiding.AreYouSureToDeleteThisShop": "Czy na pewno chcesz usunąć \"sklep\"?",
	"buiding.deleteShop": "Usuń sklep",
	"buiding.AreYouSureToDeleteThisBuilding": "Czy na pewno chcesz usunąć \"budynek\"?",
	"buiding.deleteBuilding": "Usuń budynek",
	"buiding.editBuilding": "Edytuj budynek",
	"buiding.editFloor": "Edytuj piętro",
	"buiding.editShop": "Edytuj sklep",
	"buiding.shopNameAlreadyExists": "Nazwa sklepu już istnieje",
	"buiding.shopAddSuccess": "Sklep został dodany pomyślnie",
	"buiding.floorNameAlreadyExists": "Nazwa piętra już istnieje",
	"buiding.floorAddSuccess": "Podłoga została dodana pomyślnie",
	"buiding.buildingNameAlreadyExists": "Nazwa budynku już istnieje",
	"buiding.buildingAddSuccess": "Budynek został dodany pomyślnie",
	"buiding.shopEditSuccess": "Sklep został pomyślnie edytowany",
	"buiding.buildingEditSuccess": "Budynek został pomyślnie edytowany",
	"buiding.floorEditSuccess": "Podłoga jest edytowana pomyślnie",
	"buiding.selectRobot": "Wybierz robota",
	"buiding.replacementBuildings": "Zmiana na inny budynek",
	"role.rolelist": "Lista ról",
	"role.addroles": "Dodaj rolę",
	"role.names": "Nazwa",
	"role.Entername": "Wprowadź nazwę",
	"role.PleaseEntername": "Proszę wprowadzić nazwę",
	"role.editroles": "Edytuj rolę",
	"role.deleteroles": "Usuń rolę",
	"role.Confirmdeletion": "Czy na pewno chcesz usunąć tę \"rolę\"? Nie możesz cofnąć tej akcji.",
	"role.nameAlreadyExists": "Rola już wyszła.",
	"navigationBar.personalInfo": "Informacje osobiste",
	"navigationBar.changePassword": "Zmiana hasła",
	"navigationBar.administrator": "Administrator",
	"navigationBar.domesticConsumer": "Użytkownik ogólny",
	"navigationBar.originalPsd": "Oryginalne hasło",
	"navigationBar.EnterOriginalPsd": "Wprowadź oryginalne hasło.",
	"navigationBar.newPassword": "Nowe hasło",
	"navigationBar.confirmPassword": "Potwierdź hasło",
	"navigationBar.EntertheNewPsdAga": "Wprowadź nowe hasło",
	"navigationBar.TheOriPsdCannotEmpty": "Oryginalne hasło nie może być puste",
	"navigationBar.TheNewPsdempty": "Nowe hasło nie może być puste",
	"navigationBar.PleEntertheNewPsdAga": "Proszę wprowadzić nowe hasło ponownie",
	"navigationBar.TheNewPasastheoldone": "Nowe hasło jest takie samo jak stare hasło.",
	"navigationBar.Psdisinconsistentwith": "Oba hasła są różne. Proszę potwierdzić.",
	"navigationBar.modifySuccessfully": "Zmiana zakończona sukcesem",
	"accessControl.accessControlList": "Lista kontroli dostępu",
	"accessControl.floor": "Piętro",
	"accessControl.accessControlAdd": "Dodaj kontrolę dostępu",
	"accessControl.accessControlID": "ID kontroli dostępu",
	"accessControl.selectAccessControlID": "Wybierz ID kontroli dostępu.",
	"accessControl.accessControlID-Hint": "Usługa kontroli dostępu jest potwierdzona. Niestandardowe",
	"accessControl.label": "Uwaga",
	"accessControl.pleaseLabel": "Wprowadź uwagę",
	"accessControl.deleteAccessControl-Hint": "Usunięcie kontroli dostępu spowoduje, że robot nie będzie mógł wykonywać zadań związanych z krzyżowymi drzwiami automatycznymi. Czy na pewno chcesz ją usunąć?",
	"accessControl.deleteAccessControl": "Usuń kontrolę dostępu",
	"accessControl.editAccessControl": "Edytuj kontrolę dostępu",
	"accessControl.accessControlIdExists": "Identyfikator kontroli dostępu już istnieje",
	"public.notAssociatedFloor": "Nie jest powiązany z piętrem",
	"public.notAssociatedBuilding": "Nie jest powiązany z budynkiem",
	"public.all": "Wszystko",
	"public.rules.pleaseLabel": "Proszę wprowadzić uwagę",
	"dispatcher.dispatcherList": "Lista zleceniodawców zadań",
	"dispatcher.searchName": "Wyszukaj nazwę",
	"buiding.deleteShopTips": "Proszę najpierw odłączyć wszystkie dane (roboty/mapy) sklepu",
	"buiding.deleteBuidingTips": "Proszę najpierw odłączyć wszystkie dane (roboty/mapy) budynku",
	"buiding.deleteFloorTips": "Proszę najpierw odłączyć wszystkie dane (mapy) piętra",
	"ladderControl.ladderControlList": "Lista sterowania windą",
	"ladderControl.addLadderControl": "Dodaj sterowanie windą",
	"ladderControl.grouping": "Grupowanie",
	"ladderControl.Buildings": "Budynek",
	"ladderControl.You-can-go-to-the-floor": "Dostępne piętra",
	"ladderControl.pleaseGoToBuilding": "Proszę przejść do budynku i uzyskać dostęp do sterowania windą",
	"ladderControl.grouping-tips-1": " ",
	"ladderControl.grouping-tips-2": "1. W sytuacji, gdy na tym samym piętrze znajduje się tylko jedna winda lub wiele wind, można wybrać grupę domyślną",
	"ladderControl.grouping-tips-3": "2. Windy na różnych piętrach i poczekalnie należy podzielić na grupy",
	"public.common": "Budynek",
	"ladderControl.ladderControlID": "Identyfikator sterowania windą",
	"ladderControl.selectLadderControlID": "Wybierz identyfikator sterowania windą",
	"ladderControl.ladderControlID-tips": "Sprawdź w serwisie kontroli wind/ kontroli dostępu, czy klient skonfigurował już ID sterowania windą",
	"ladderControl.groupingPlaceholder": "Wprowadź lub wybierz grupę (np.: windy wysokiego składowania)",
	"ladderControl.deleteladderControl": "Usuń sterowanie windy",
	"ladderControl.deleteladderControl-tips": "Usunięcie sterowania windą spowoduje, że robot nie będzie mógł wykonywać zadań związanych z przemieszczaniem się między piętrami. Czy na pewno chcesz go usunąć?",
	"ladderControl.ladderControlIdExists": "Identyfikator sterowania windą już istnieje",
	"login.remTheNub": "Przypomnij sobie hasło",
	"login.oldPasswordError": "Stare hasło jest nieprawidłowe",
	"login.confirmAndNewParrword": "Te dwa hasła nie są takie same",
	"robot.advertising": "Reklamy",
	"homes.buildingDeliveryTimes": "Czas dostawy",
	"robot.detail": "Szczegóły dotyczące robotów",
	"robot.robotModel": "Typ robota",
	"robot.header_control-2": "Płyta główna Android",
	"robot.under_mirror-2": "Obraz OS podwozia",
	"robot.under_master-2": "Sterowanie podwoziem",
	"robot.under_control-2": "Płyta główna podwozia",
	"robot.nav": "Algorytm nawigacji",
	"robot.up_rgbd": "Górny RGBD",
	"robot.down_rgbd": "Dolny RGBD",
	"robot.camera": "Kamera górna",
	"robot.ss": "Przednia kamera",
	"robot.rgbd_top_depth": "Górna głębokość RGBD",
	"robot.rgbd_top_color": "Górny kolor RGBD",
	"robot.rgbd_bottom_depth": "Dolna głębokość RGBD",
	"robot.rgbd_bottom_color": "Dolny kolor RGBD",
	"robot.ultrasonic1": "Lewy ultradźwięk",
	"robot.ultrasonic2": "Prawy ultradźwięk",
	"robot.motor1": "Lewy silnik",
	"robot.motor2": "Prawy silnik",
	"robot.detection": "Wykrywanie obiektów",
	"buiding.builNameAlreadyExists": "Nazwa budynku już istnieje",
	"robot.bindingSuccess": "Wiązanie zakończone sukcesem",
	"robot.notActive": "Nie aktywtowany",
	"robotinfo.logdown": "Nieaktywny",
	"robotinfo.Logtype": "Pobieranie dziennika",
	"robotinfo.displayboard": "Typ dziennika",
	"robotinfo.maincontrolpanel": "Płyta wyświetlacza",
	"robotinfo.powerstrip": "Główna płyta sterowania",
	"robotinfo.navigationdata": "Płyta zasilania",
	"robotinfo.Plethedate": "Dane nawigacyjne",
	"robotinfo.Plethetime": "Wybierz datę",
	"robotinfo.acquire": "Wybierz godzinę",
	"robotinfo.Packinglog": "Pobieranie",
	"robotinfo.Uploadinglogfiles": "Pakowanie dzienników",
	"robotinfo.Gettinguploadstatus": "Przesyłanie pliku dziennika",
	"robotinfo.acquiresuccess": "Uzyskiwanie statusu przesyłania",
	"robotinfo.clicktodownload": "Pozyskano pomyślnie",
	"robotinfo.Plelogtype": "Kliknij, aby pobrać",
	"robotinfo.Plestartdateandtime": "Wybierz typ dziennika",
	"robotinfo.Pleanenddateandtime": "Wybierz datę i godzinę rozpoczęcia",
	"robotinfo.Nologtime": "Wybierz datę i godzinę zakończenia",
	"robotinfo.logtaskispackagedpackged": "Brak dziennika dla tego okresu",
	"robotinfo.failtoget": "Robot aktualnie pakuje lub przesyła dzienniki.",
	"robotinfo.Failedtopackage1/2": "Nie udało się pobrać",
	"robotinfo.Failedtopackage2/2": "Nie udało się spakować 1/2",
	"robotinfo.failtoupload": "Nie udało się spakować 2/2",
	"public.unrelatedBuildings": "Przesyłanie nie powiodło się",
	"buiding.sameFloorNumber": "Nie skojarzono z budynkiem",
	"navigationBar.pleaseEnterOriginalPsd": "Ten sam numer piętra już istnieje w tym budynku",
	"navigationBar.newpassword": "Wprowadź oryginalne hasło",
	"navigationBar.pleaseNewpassword": "Wprowadź nowe hasło (wprowadź 6-20 cyfr, język angielski, symbole)",
	"login.nnterprise-number-error": "Wprowadź ponownie nowe hasło",
	"home.Fullrobot": "Błąd identyfikatora przedsiębiorstwa",
	"map.displaytext": "Wszystkie roboty",
	"map.nonetext": "Wyświetl tekst",
	"robot.detection-1": "Nie wyświetlaj tekstu",
	"robot.detection-2": "Wykrywanie obiektów 2",
	"robot.detection-3": "Wykrywanie obiektów 3",
	"robot.detection-4": "Wykrywanie obiektów 4",
	"robot.current_systemVersion": "Aktualna wersja",
	"robot.cumulativeTimes": "Łączny czas dostawy",
	"robot.cumulativeTime": "Łączny czas dostawy",
	"home.hour": "h",
	"home.min": "min",
	"home.deliverytimes": "Czasy dostawy (czasy)",
	"login.actpaswdinco": "Nieprawidłowa nazwa użytkownika lub hasło",
	"login.enterpriseerror": "Błąd identyfikatora przedsiębiorstwa",
	"home.numberofworkmachs": "Liczba pracujących robotów",
	"home.workinghours": "Godziny pracy",
	"login.account_expired": "Konto wygasło. Zaloguj się ponownie",
	"robot.CADEBOT_rankingList_tips": "Ranking czasów dostawy w miejscu docelowym",
	"robot.setLabel": "Pomyślnie ustawiono uwagę",
	"homes.nearly-7-days-mileage": "Trend przebiegu w ciągu ostatnich 7 dni",
	"robot.robotisofflineobtalogs": "Dzienniki są niedostępne, ponieważ robot jest offline",
	"buiding.buid-illustrate": "Budynek (dla wielu kondygnacji)",
	"buiding.shop-illustrate": "Sklep (dla pojedynczej kondygnacji)",
	"buiding.new-pleaseFloorName": "Wprowadź nazwę piętra",
	"route.admage": "Reklamy",
	"route.asset": "Biblioteka zasobów",
	"route.ads": "Wydanie reklamy",
	"route.adsDetail": "Szczegóły ogłoszenia",
	"route.addAds": "Dodaj ogłoszenie",
	"route.editAds": "Edycja ogłoszeń",
	"ad.asset": "Lista zasobów",
	"ad.freeSpace": "Pozostało miejsce",
	"ad.uploadAsset": "Prześlij zasoby",
	"ad.filename": "Nazwa pliku",
	"ad.type": "Typ",
	"ad.memory": "Pamięć",
	"ad.video": "Wideo",
	"ad.image": "Obraz",
	"ad.uploadTime": "Czas przesyłania",
	"ad.uploadProgress": "Postęp przesyłania",
	"ad.uploadSuccess": "Przesyłanie powiodło się",
	"ad.operation": "Operacja",
	"ad.check": "Widok",
	"ad.delete": "Usuń",
	"ad.confirm": "Potwierdź",
	"ad.cancel": "Anuluj",
	"ad.deleteSuccess": "Usunięto pomyślnie",
	"ad.back": "Zwrot",
	"ad.deleteAsset": "Usuwanie zasobów",
	"ad.deleteAssetWarningMessage": "Usunięte zasoby nie zostaną odzyskane, potwierdzić usunięcie?",
	"ad.extLimit": "Można przesyłać tylko pliki w formatach JPG, PNG, MP4, AVI, MOV, WMV, RMVB.",
	"ad.sizeLimit": "Pojedynczy plik nie może przekraczać 1 GB",
	"ad.syncFail": "pobieranie nie udane",
	"ad.syncComplete": "Pobieranie zakończone",
	"ad.downloadComplete": "Konfiguracja w toku",
	"ad.downloadWaiting": "Nie pobrano",
	"ad.name": "Nazwa",
	"ad.playTime": "Czas odtwarzania",
	"ad.materialNum": "Liczba zasobów",
	"ad.robotNum": "Liczba obsadzonych robotów",
	"ad.startTime": "Czas publikacji",
	"ad.addSchema": "Dodaj reklamę",
	"ad.copySchema": "Kopiuj plan",
	"ad.edit": "Edycja",
	"ad.publish": "Opublikuj",
	"ad.deleteDraft": "Usuń plan",
	"ad.save": "Zapisz",
	"ad.preview": "Podgląd",
	"ad.setDefault": "Użyj teraz",
	"ad.setDefaultPlease": "Ustaw, jeśli jest domyślne",
	"ad.yes": "Tak",
	"ad.no": "Nie",
	"ad.deleteDraftWarningMessage": "Potwierdzić usunięcie planu?",
	"ad.draft": "Nie opublikowano",
	"ad.schemaDetail": "Szczegóły planu",
	"ad.schemaContent": "Zawartość planu",
	"ad.syncRecord": "Zsynchronizowane nagrywanie",
	"ad.robotSn": "Usuwanie robotów",
	"ad.robotSelect": "Wybierz robota",
	"ad.nameInput": "Wprowadź nazwę planu",
	"ad.robotSelectPlease": "Wybierz robota",
	"ad.nameInputPlease": "Wprowadź nazwę planu",
	"ad.materialList": "Lista zasobów",
	"ad.materialListDescriptions": "Wymiar ekranu reklamowego: 1080*1920. Przeciągnij ramkę materiału, aby dostosować kolejność.",
	"ad.setting": "Ustawienia umieszczania",
	"ad.period": "Okres",
	"ad.allDay": "Cały dzień",
	"ad.someTime": "Okres czasu",
	"ad.beginTime": "Czas rozpoczęcia",
	"ad.endTime": "Czas zakończenia",
	"ad.materialLib": "Biblioteka zasobów",
	"ad.materialNumber": "Liczba zasobów",
	"ad.removeScreen": "Usuń podzielony ekran",
	"ad.removeScreenConfirm": "Potwierdzić usunięcie podzielonego ekranu?",
	"ad.playTimeDuration": "Czas trwania odtwarzania",
	"ad.picturePlayTime": "Czas trwania odtwarzania obrazu",
	"ad.addPeriod": "Dodaj przedział czasowy",
	"ad.addPeriodLimit": "Można dodać 6 różnych przedziałów czasowych",
	"ad.totalTime": "Całkowity czas trwania",
	"ad.saveSuccess": "Pomyślne zapisanie",
	"ad.publishSuccess": "Publikacja powiodła się",
	"ad.addPeriodFail": "Masz już całodniowy przedział czasowy, nie można go dodać.",
	"ad.publishFail": "Publikacja nie powiodła się",
	"ad.playTimeNoEmpty": "Czas odtwarzania nie może być pusty",
	"ad.materialListNoEmpty": "Podzielony ekran nie może pozostać pusty",
	"ad.robot": "Robot",
	"ad.robotOffline": "Robot offline",
	"ad.robotOfflineAndCanNotLaunch": "Następujące roboty są w trybie offline i nie można ich umieścić",
	"ad.robotUplineOrSaveDraft": "Należy obsługiwać robota w trybie online lub najpierw zapisać plan jako wersję roboczą.",
	"ad.syncStatus": "Stan pobierania robota",
	"ad.reSync": "Opublikuj ponownie",
	"ad.goBackList": "Powrót do listy",
	"ad.confirmPublish": "Czy na pewno chcesz opublikować plan?",
	"ad.robotOfflineToConfirmPublish": "Poniższy robot jest offline, czy możesz potwierdzić publikację?",
	"ad.addCancelConfirm": "Czy chcesz potwierdzić, że bieżąca zawartość nie zostanie zapisana po powrocie?",
	"ad.refresh": "Odśwież",
	"ad.publishTime": "Czas publikacji",
	"ad.lastModifyTime": "Czas ostatniej modyfikacji",
	"ad.publisher": "Opublikowane przez",
	"ad.editor": "Zmodyfikowany przez",
	"ad.timeOverlap": "Okresy odtwarzania nie mogą się nakładać, sprawdź",
	"ad.endTimeMustLargerThanStartTime": "Czas zakończenia okresu odtwarzania musi być dłuższy niż czas rozpoczęcia.",
	"ad.cannotDeleteAssetUsed": "Ten klip ma odniesienie i nie można go usunąć.",
	"ad.deletePeriodWarningMessage": "Czy chcesz potwierdzić usunięcie przedziałów czasowych?",
	"ad.complete": "Gotowe",
	"ad.fail": "Nie udało się",
	"ad.nameInputIllegal": "Nazwa planu nie może zawierać znaków specjalnych",
	"ad.nameDuplicate": "Nazwa planu już istnieje",
	"ad.updateTime": "Ostatni czas modyfikacji",
	"role.TherolesDeletingfails": "Rola jest powiązana z kontem, usunięcie nie powiodło się",
	"account.Changeofauthority": "Zmiana uprawnień",
	"account.ThepermisschgePleaseagain": "Uprawnienia tego konta zostały zmienione",
	"disinfect.Unknowncause": "Nie jest znany powód",
	"robot.accumulatedTaskExecutionTimes": "Łączna liczba wykonanych zadań",
	"home.minute": "minuty",
	"homes.Statisticstasks": "Statystyki robota wykonującego zadania (praca w toku)",
	"disinfect.Initilizati": "Inicjalizacja nie powiodła się",
	"disinfect.Failedtogetlocation": "Nie udało się uzyskać lokalizacji",
	"disinfect.pointisoffthemap": "Punkt docelowy znajduje się poza mapą",
	"disinfect.onastaticobstacle": "Punkt docelowy znajduje się na statycznej przeszkodzie",
	"disinfect.therearenoroadsonthestaticmap": "Brak ścieżki na mapie statycznej",
	"disinfect.Startingpointobstacle": "Przeszkoda na początku",
	"disinfect.Lossoflocation": "Utrata lokalizacji",
	"disinfect.Failedtolocatethelostlocalpath": "Częściowe planowanie ścieżki nie powiodło się",
	"disinfect.Clifftriggercancellation": "Anulowanie wyzwalacza klifu",
	"disinfect.Emergencystoptriggerscancellation": "Anulowanie wyzwalacza zatrzymania awaryjnego",
	"disinfect.Collisionbartriggercancel": "Anulowanie wyzwalacza pasa antykolizyjnego",
	"disinfect.overtime": "Przekroczenie limitu czasu",
	"disinfect.Chargingpiledetectionfailed": "Wykrycie doku ładującego nie powiodło się",
	"disinfect.Pilefailure": "Nie udało się utworzyć stosu",
	"disinfect.GlobalpathplanningfailedProcedure": "Globalne planowanie ścieżki nie powiodło się",
	"disinfect.Slopetriggercancellation": "Anulowanie wyzwalacza nachylenia",
	"disinfect.NavigationrecoverybeProcedure": "Odzyskiwanie nawigacji nie powiodło się",
	"disinfect.Navigateoutnarrowchannel": "Wąska ścieżka jest zablokowana",
	"disinfect.Androidtasktimeout": "Limit czasu zadania",
	"disinfect.elsesa": "inne błędy",
	"robot.historicaldelete": "Dane historyczne tego robota zostaną usunięte, potwierdzić usunięcie?",
	"robot.delfaild": "Usunięcie nie powiodło się",
	"robot.LoRa_ID": "LoRa ID",
	"robot.associatedSIMCard": "Powiązana karta SIM",
	"robot.accumulatedUsageTraffic": "Łączne wykorzystanie ruchu",
	"robot.trafficUsageMonth": "Miesięczne wykorzystanie ruchu",
	"robot.newrgbd_bottom_depth": "Dolna głębokość RGBD",
	"robot.batteryTest": "Wykrywanie akumulatora",
	"robot.Partial_information_update_failed": "Nie udało się zaktualizować niektórych informacji",
	"robot.update_failed": "aktualizacja nie powiodła się",
	"robot.update_robot_datasSuccess": "Pomyślnie uzyskaj najnowsze dane robota",
	"ad.waitForDownload": "czeka na pobranie",
	"ad.startDownload": "Rozpocznij pobieranie",
	"ad.offLineAndCannotDownload": "Urządzenie offline, nie można pobrać",
	"ad.syncing": "synchronizuję...",
	"robot.robot_does_not_exist": "robota nie istnieje",
	"robot.robot_current_enterprise": "Roboty opuściły obecne przedsiębiorstwo",
	"ad.notEnoughSpace": "Nie ma wystarczającej ilości miejsca na materiały firmowe, wyczyść pliki na czas",
	"ad.addAsset": "dodać materiał",
	"robot.batteryCommunication": "komunikacja baterii",
	"disinfect.Thetargetpointisobstacle": "Punkt docelowy znajduje się na dynamicznej przeszkodzie",
	"disinfect.Therearenoroadsonadynamicmap": "Na mapie dynamicznej nie ma drogi",
	"robot.buildingRobotErrorTips_10019": "Liczba robotów w tym sklepie osiągnęła górną granicę 16, zmień budynek (sklep)",
	"robot.buildingRobotErrorTips_10020": "Błąd generowania LoraId",
	"map.VirtualWall": "Wirtualna ściana",
	"map.Qrcode": "Kod QR",
	"map.regions": "obszar",
	"map.anchorpoints": "punkt lokalizacji",
	"robot.noSearchResults": "Brak wyników wyszukiwania",
	"robot.accountInformationHasBeenModified": "Informacje o koncie zostały zmodyfikowane",
	"public.tips": "wenk",
	"public.agreeWith": "zgadzać się",
	"public.iHaveReadAndAgree": "Przeczytałem i zgadzam się",
	"public.userAgreement": "Zgoda użytkownika",
	"public.gentle": "En",
	"public.privacyAgreement": "Polityka prywatności",
	"public.pleaseAgreeFirst": "najpierw zgódź się",
}